
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorGpsLow as ObiSensorGpsLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-gps-low.js';
 
 
 

 
 export const ObiSensorGpsLow = createComponent({
   react: React,
   tagName: 'obi-sensor-gps-low',
   elementClass: ObiSensorGpsLowElement,
   events: {
     
   }
  });
 
 